import React from 'react';

// Internal Import
import { deep } from '../theme/colors';
import { formatRupiah } from '../utils/format-rupiah';
import { AppBarComponent } from '../components/appbar';
import { FooterComponent } from '../components/footer';
import { TypeSelect } from '../modules/types/home.type';
import { ScrollToTopComponent } from '../components/scrollToTop';

// External Import
import { common } from "@mui/material/colors";
import { useNavigate, useParams } from 'react-router-dom';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';


import {
    Box,
    Grid,
    Stack,
    Button,
    Typography,
} from '@mui/material';



const arrType: TypeSelect[] = [
    {
        id: "1",
        name: "Residential"
    },
    {
        id: "2",
        name: "Commercial"
    },
    {
        id: "3",
        name: "Apartment"
    }
];

const arrHarga: TypeSelect[] = [
    {
        id: "100000000",
        name: "100 Juta"
    },
    {
        id: "200000000",
        name: "200 Juta"
    },
    {
        id: "300000000",
        name: "300 Juta"
    },
    {
        id: "400000000",
        name: "400 Juta"
    },
    {
        id: "500000000",
        name: "500 Juta"
    }
];

const dataProduct = [
    {
        id: 3,
        name: 'cluster varena',
        proyek: 'citraraya tangerang',
        desc: 'Cluster EcoResidence di Ecopolis at CitraRaya Tangerang. Cluster ekslusif persembahan dari Ciputra Group dan Mitsui Fudosan Asia.',
        price: "500000000",
        img: require('./../asset/Varrena.jpg')
    },
];


const responseProduct = {
    status: 200,
    message: "successful",
    data: dataProduct,
    page: 1,
    next: true
}



export interface ListProductProps { }
export const ListProductScreen: React.FC<ListProductProps> = () => {

    let navigate = useNavigate();

    let { s, t, min, max } = useParams();

    const [search, setSearch] = React.useState<string>('');

    const [idType, setIdType] = React.useState<string>('0');
    const [idPriceMin, setIdPriceMin] = React.useState<string>('0');
    const [idPriceMax, setIdPriceMax] = React.useState<string>('0');
    const [dataType, setDataType] = React.useState<TypeSelect[]>(arrType);
    const [dataPriceMin, setPriceMin] = React.useState<TypeSelect[]>(arrHarga);
    const [dataPriceMax, setPriceMax] = React.useState<TypeSelect[]>(arrHarga);
    React.useEffect(() => {
        if (idPriceMin != "0") {
            let priceMax: TypeSelect[] = arrHarga.filter(o => parseInt(o.id) > parseInt(idPriceMin));
            setIdPriceMax("0");
            setPriceMax(priceMax);
        }
    }, [idPriceMin]);

    React.useEffect(() => {
        if (s!=undefined&&s!=="0") { setSearch(s); }
        if (t!=undefined&&t!=="0") { setIdType(t); }
        
        if (min!=undefined&&min!=="0") { setIdPriceMin(min); }
        if (max!=undefined&&max!=="0") { setIdPriceMax(max); }
    }, []);


    return (
        <Stack>
            <AppBarComponent />
            <ScrollToTopComponent />


            {/* // Banner Content // */}
            <Box
                sx={{
                    width: '96%',
                    objectFit: 'cover',
                    marginTop: 4,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderRadius: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: 'url(./assets/images/masterplan.jpg)'
                }}
            >
                <Box
                    sx={{
                        flex: '1',
                        display: 'flex',
                        borderRadius: 1.5,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)'
                    }}
                >
                    <Typography
                        color={common.white}
                        sx={{

                            width: '90%',
                            fontWeight: '500',
                            lineHeight: '1.1em',
                            fontFamily: 'Montserrat',
                            textTransform: 'capitalize',

                            marginTop: 8,
                            textAlign: 'center',
                            marginBottom: 2.6,
                            marginLeft: 'auto',
                            marginRight: 'auto',


                            fontSize: { xs: '1.75em', sm: '2.5em', md: '3em' },
                        }}
                    >
                        we bring dream homes to reality.
                    </Typography>

                    <Grid container sx={{
                        width: '90%',
                        borderRadius: 1,
                        marginBottom: 6,
                        marginLeft: 'auto',
                        marginRight: 'auto',

                        paddingTop: 1,
                        paddingBottom: 2,

                        justifyContent: 'space-evenly',
                        backgroundColor: 'rgba(217, 217, 217, 0.8)'
                    }}>
                        <Grid item xs={11} sm={11} md={3} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <SearchRoundedIcon sx={{ width: 24, fill: deep.main }} />
                            <input
                                type='text'
                                value={search}
                                placeholder='Search location/proyek'
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    flex: 1,
                                    width: '100%',
                                    marginLeft: 4,
                                    height: '100%',
                                    border: 'unset',
                                    outline: 'unset',
                                    fontSize: '0.8em',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                }}
                            />
                        </Grid>
                        <Grid item xs={11} sm={3.6} md={1.75} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <select
                                value={idType}
                                onChange={e => setIdType(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    outline: 0,
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: '0.8em',
                                    textAlign: 'center',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                    color: parseInt(idType) == 0 ? "rgba(0,0,0,0.5)" : common.black
                                }}
                            >
                                <option disabled selected value="0">- Type Property -</option>
                                {dataType.map((item: TypeSelect, index: number) => {
                                    return (
                                        <option 
                                            key={item.id} 
                                            value={item.id}
                                            style={{backgroundColor: 'transparent'}}
                                        >{item.name}</option>
                                    );
                                })}

                            </select>
                        </Grid>
                        <Grid item xs={11} sm={3.6} md={1.75} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <select
                                value={idPriceMin}
                                onChange={e => setIdPriceMin(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    outline: 0,
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: '0.8em',
                                    textAlign: 'center',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                    color: parseInt(idPriceMin) == 0 ? "rgba(0,0,0,0.5)" : common.black
                                }}
                            >
                                <option disabled selected value="0">- Min Price -</option>
                                {dataPriceMin.map((item: TypeSelect, index: number) => {
                                    return (
                                        <option 
                                            key={item.id} 
                                            value={item.id}
                                            style={{backgroundColor: 'transparent'}}
                                        >{item.name}</option>
                                    );
                                })}

                            </select>
                        </Grid>
                        <Grid item xs={11} sm={3.6} md={1.75} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <select
                                value={idPriceMax}
                                onChange={e => setIdPriceMax(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    outline: 0,
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: '0.8em',
                                    textAlign: 'center',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                    color: parseInt(idPriceMax) == 0 ? "rgba(0,0,0,0.5)" : common.black
                                }}
                            >
                                <option disabled selected value="0">- Max Price -</option>
                                {dataPriceMax.map((item: TypeSelect, index: number) => {
                                    return (
                                        <option 
                                            key={item.id} 
                                            value={item.id}
                                            style={{backgroundColor: 'transparent'}}
                                        >{item.name}</option>
                                    );
                                })}

                            </select>
                        </Grid>
                        <Grid item xs={11} sm={11} md={1.75} sx={{
                            marginTop: 1,
                            borderRadius: 1,
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <Button
                                onClick={() => { }}
                                sx={{
                                    flex: 1,
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 1,
                                    fontSize: '0.8em',
                                    color: common.white,
                                    backgroundColor: '#003974'
                                }}
                            >Submit</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            {/* // Product List // */}
            <Box
                sx={{
                    width: '88%',
                    display: 'flex',
                    paddingBottom: 12,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: { xs: 6, lg: 10 },
                }}
            >
                <Box sx={{
                    mb: 2,
                    mt: 2,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <Typography
                        color={common.black}
                        sx={{
                            fontWeight: '500',
                            fontFamily: 'Montserrat',
                            textTransform: 'uppercase',
                            fontSize: { xs: 10, sm: 18, md: 20 },
                        }}
                    >
                        product list
                    </Typography>
                </Box>

                <Grid container sx={{
                    width: '100%',

                    paddingTop: 1,
                    paddingBottom: 3,

                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                }}>
                    {dataProduct.slice(0, 3).map((item) => {
                        return (
                            <Grid item xs={3.83} sm={3.83} sx={{
                                mb: 4,
                                p: 0.75,
                                borderRadius: 1,
                                backgroundColor: common.white,
                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
                            }}>
                                <div>
                                    <img
                                        src={item.img}
                                        style={{
                                            width: '100%',
                                            height: '24vw',
                                            borderRadius: '1vw',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            mt: { xs: 1, sm: 2 },
                                            mr: { xs: 1, sm: 2 },
                                            ml: { xs: 1, sm: 2 },
                                            fontWeight: 'bold',
                                            fontFamily: 'Roboto',
                                            textTransform: 'capitalize',
                                            fontSize: { xs: 6, sm: 12, md: 18, lg: 22 },
                                            

                                            overflow: 'hidden',
                                            WebkitLineClamp: 2,
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            mr: { xs: 1, sm: 2 },
                                            ml: { xs: 1, sm: 2 },
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat',
                                            textTransform: 'capitalize',
                                            fontSize: { xs: 4, sm: 8, md: 10, lg: 14 },

                                            overflow: 'hidden',
                                            WebkitLineClamp: 2,
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                        }}
                                    >
                                        {item.proyek}
                                    </Typography>
                                </div>

                                <Typography
                                    color={'#999999'}
                                    sx={{
                                        mt: { xs: 1, sm: 3 },
                                        mr: { xs: 1, sm: 2 },
                                        ml: { xs: 1, sm: 2 },
                                        maxLines: 2,
                                        fontWeight: '400',
                                        fontFamily: 'Roboto',
                                        textTransform: 'capitalize',
                                        fontSize: { xs: 6, sm: 8, md: 16 },

                                        overflow: 'hidden',
                                        WebkitLineClamp: 3,
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                    }}
                                >
                                    {item.desc}
                                </Typography>

                                <div>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', md: 'row' },
                                        alignItems: { xs: 'flex-start', md: 'flex-end' },
                                        mt: { xs: 2, sm: 4 },
                                        mb: { xs: 0.5, sm: 1 },
                                        pl: { xs: 1, sm: 2 },
                                        pr: { xs: 1, sm: 2 },
                                        justifyContent: { xs: 'flex-start', md: 'space-between' }
                                    }}>
                                        <Typography
                                            color={common.black}
                                            sx={{
                                                fontWeight: '400',
                                                fontFamily: 'Roboto',
                                                textTransform: 'capitalize',
                                                fontSize: { xs: 3, sm: 6, md: 8, lg: 12 },
                                            }}
                                        >price from</Typography>
                                        <Typography
                                            color={common.black}
                                            sx={{
                                                fontWeight: '700',
                                                fontFamily: 'Roboto',
                                                textTransform: 'capitalize',
                                                fontSize: { xs: 6, sm: 12, md: 16, lg: 20 },
                                            }}
                                        >{formatRupiah(item.price)}</Typography>
                                    </Box>
                                    <Button
                                        fullWidth
                                        size='small'
                                        variant='contained'
                                        sx={{ 
                                            fontSize: { xs: 7, sm: 12, md: 18 },
                                            borderRadius: { xs: 1, sm: 1.5, md: 2 },
                                            py: { xs: 0.5, sm: 1, md: 1 }
                                        }}
                                        onClick={() => navigate(`/product/${item.id}`)}
                                    >Detail</Button>
                                </div>
                            </Grid>
                        )
                    })}
                </Grid>
                {/* {responseProduct.next && (
                    <Button
                        onClick={() => navigate('/products')}
                        size='small'
                        variant='outlined'
                        sx={{
                            borderRadius: 1,
                            fontSize: { xs: 8, sm: 12, md: 16 },
                        }}
                    >
                        {'SEE MORE...'}
                    </Button>
                )} */}
            </Box>

            {/* // Footer // */}
            <FooterComponent />

        </Stack>
    )
};